<template>
  <advanced-table
    :headers="headers"
    :filters="filters"
    :sortBy="'startDate'"
    :descending="true"
    :resource="resource"
    :optionLists="optionLists"
  />
</template>

<script>
import AdvancedTable from "@/components/AdvancedTable.vue";
import { format } from "date-fns";

export default {
  data() {
    return {
      headers: [
        {
          text: "מדינה",
          value: "country",
          align: "right",
          visible: true,
          width: "200",
          displayFunc: (data, key) => {
            let country = this.entityById(
              "countries",
              data[key] && data[key]._id ? data[key]._id : data[key]
            );
            return country ? country.name : '';
          }
        },
        {
          text: "איזור",
          value: "region",
          align: "right",
          visible: true,
          width: "200",
          displayFunc: (data, key) => {
            let region = this.entityById(
              "regions",
              data[key] && data[key]._id ? data[key]._id : data[key]
            );
            return region ? region.name : '';
          }
        },
        {
          text: "סוג ספק",
          value: "partnerType",
          align: "right",
          visible: true,
          width: "200",
          displayFunc: (data, key) => {
            let partnerType = this.entityById(
              "partnerTypes",
              data[key] && data[key]._id ? data[key]._id : data[key]
            );
            return partnerType ? partnerType.titlePlural : '';
          }
        },
        {
          text: "ערך תקן",
          value: "standardValue",
          align: "right",
          visible: true,
          width: "200",
          displayFunc: (data, key) => {
            return data[key];
          }
        },
        {
          text: "ערך בפועל",
          value: "realValue",
          align: "right",
          visible: true,
          width: "200",
          displayFunc: (data, key) => {
            return data[key];
          }
        },
        {
          text: "הפרש",
          value: "delta",
          align: "right",
          visible: true,
          width: "200",
          displayFunc: (data, key) => {
            return data[key];
          }
        },
        
      ],
      filters: [
        {
          type: "COMBOBOX",
          label: "מדינות",
          model: "countries",
          items: "countries",
          itemText: "name",
          itemValue: "_id",
          active: true
        },
        {
          type: "COMBOBOX",
          label: "איזורים",
          model: "regions",
          items: "regions",
          itemText: "name",
          itemValue: "_id",
          active: true
        },
        {
          type: "COMBOBOX",
          label: "סוגי ספקים",
          model: "partnerTypes",
          items: "partnerTypes",
          itemText: "title",
          itemValue: "_id",
          active: true
        },
        {
          type: "BOOLEAN",
          label: "רק חוסרים",
          model: "onlyShortages",
          active: true
        }
      ]
    };
  },
  computed: {
    countries() {
      return this.$store.getters["entityList"]("countries").filter(item => {
        return item.isActive;
      });
    },
    regions() {
      return Object.values(this.$store.state.entities.regions);
    },
    partnerTypes() {
      return Object.values(this.$store.state.entities.partnerTypes);
    },
    resource() {
      return this.$store.state.resources["standardReportRow"];
    },
    optionLists() {
      return {
        regions: this.regions,
        countries: this.countries,
        partnerTypes: this.partnerTypes
      };
    }
  },
  methods: {
    entityById(entityType, id) {
      return this.$store.getters["entity"](entityType, id);
    }
  },
  watch: {},
  components: {
    AdvancedTable
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/reports/Standards.vue